import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import cognitoService from '../services/cognitoService';

const Login = () => {
  const { currentUser, loading } = useAuth();
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // If user is already logged in, redirect to profile
  useEffect(() => {
    if (currentUser) {
      navigate('/profile');
    }
  }, [currentUser, navigate]);

  const handleLoginClick = async () => {
    try {
      // Check if Cognito domain is configured for hosted UI
      if (cognitoService.redirectToHostedUI) {
        await cognitoService.redirectToHostedUI();
      } else {
        setError('Cognito Hosted UI is not configured. Please contact your administrator.');
      }
    } catch (err) {
      setError(err.message || 'Failed to redirect to login page');
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Sign in to your account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" role="alert">
            {error}
          </div>
        )}

        <div className="space-y-6">
          <div>
            <button
              onClick={handleLoginClick}
              disabled={loading}
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-indigo-400"
            >
              {loading ? 'Loading...' : 'Sign in with Cognito'}
            </button>
          </div>
        </div>

        <p className="mt-10 text-center text-sm text-gray-500">
          Not a member?{' '}
          <Link to="/register" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
            Register now
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
